export default function Notifications() {
    this.notificationContainer = document.querySelector('.notifications-container');
}

Notifications.prototype.setNotificationsPosition = function (bottom) {
    this.notificationContainer.style.bottom = isNaN(bottom) ? bottom : `${bottom}px`;
};

Notifications.prototype.notify = function (text) {
    this.notificationContainer.appendChild(
        this.getNotification(text)
    );
}

Notifications.prototype.getNotification = function (text) {
    let notification = document.createElement('span');
    notification.className = 'notifications-container__notification';
    notification.textContent = text;

    notification.addEventListener('animationend', function () {
        this.remove();
    });

    setTimeout(() => {
        notification.classList.add('notifications-container__notification--hidden');
    }, 3000);

    return notification;
};
